module.exports = __webpack_public_path__ + "static/media/tableNav_blu.6904ee1a.svg";